import { chunk } from 'lodash';

import { getFormValuesObject } from './getFormValuesObject';
import { getRowChip, getRowFieldQualifierValue } from './getRow';
import { parseMaskedFieldQualifierValue } from './parseMaskedFieldQualifierValue';
import { BooleanChip, booleanOperatorRegex, FormValues } from '../constants';

const getFormValuesWithInvalidQuery = (query: string): FormValues => {
  const formValues = getFormValuesObject();

  formValues[0].value = query;
  formValues[0].isInvalid = true;

  return formValues;
};

export const createBooleanChipQuery = (chip: BooleanChip) =>
  ` ${chip.toUpperCase()} `;
export const andBooleanChip = createBooleanChipQuery(BooleanChip.and);

export const parseMaskedAdvancedSearchQuery = (query: string): FormValues => {
  const regex = new RegExp(`${booleanOperatorRegex}(?=\\w+ \\w+ ".*")`, 'g');
  const [firstRow, ...rowsWithChips] = query.split(regex);
  const rowValues = [
    [andBooleanChip, firstRow],
    ...chunk(rowsWithChips, 2),
  ].map(row => [getRowChip(row), getRowFieldQualifierValue(row)]);

  try {
    return rowValues.reduce((values: FormValues, row, index) => {
      const fieldQualifierValue = getRowFieldQualifierValue(row);

      values[index] = {
        ...parseMaskedFieldQualifierValue(fieldQualifierValue),
        ...(index > 0 && {
          booleanChip: getRowChip(row) as BooleanChip,
        }),
      };

      return values;
    }, getFormValuesObject());
  } catch (error) {
    return getFormValuesWithInvalidQuery(query);
  }
};
